module.exports = __webpack_public_path__ + "static/media/campaigns.3adf4315.svg";